export enum Endpoint {
    ClientApi = '/api/client',
    GatewayApi = '/api/gateway',
}
